import React from 'react'
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from '../components/Common/PageBanner'
import Footer from "../components/App/Footer"
import ServiceDetailsContentz from '../components/ServiceDetailsz/ServiceDetailsContentz'
import RelatedServicesz from '../components/ServiceDetailsz/RelatedServicesz'

const Details = () => {
    return (
        <Layout>
            <Navbar />
            <PageBanner
                pageTitle="BO / BODS  "
                homePageText="Home"
                homePageUrl="/"
                activePageText="Service Details"
            />
            <ServiceDetailsContentz />
            <RelatedServicesz />
            <Footer />
        </Layout>
    );
}

export default Details